import { Component, HostBinding, Input } from '@angular/core';
import { TranslationService } from '@core/services/local/translation.service';
import {
  colorType,
  buttonConfig,
  sizeType,
  buttonThemeType,
  labelType,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { IconsComponent } from '../icons/icon.component';
import { NgComponentOutlet } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'button-component',
  templateUrl: './button.component.html',
  imports: [TranslateModule, IconsComponent, NgComponentOutlet, NgbTooltip, RouterModule],
  styleUrls: ['./button.component.scss'],
})
export class CustomButtonComponent {
  @HostBinding('style.display') display = '';
  @Input({ required: true }) config!: buttonConfig;
  @Input({ required: false }) data!: any;

  protected iconSizes = {
    sm: '15',
    md: '20',
    lg: '25',
  };

  protected defaultConfig = {
    theme: 'dark' as buttonThemeType,
    icon: {
      size: this.iconSizes.sm,
    },
    btn: {
      size: 'sm' as sizeType,
      color: 'primary' as colorType,
    },
  };

  constructor(private translate: TranslationService) {}

  ngOnInit() {
    if (!this.config.theme) this.config.theme = this.defaultConfig.theme;
    if (!this.config.color) this.config.color = this.defaultConfig.btn.color;
    if (!this.config.size) this.config.size = this.defaultConfig.btn.size;
  }

  getLabelTranslation(label: labelType) {
    return this.translate.translate({
      keys: [label.key],
      params: { [label.key]: label.params },
      separator: ' ',
    });
  }
}
